import { render, staticRenderFns } from "./FixBalances.vue?vue&type=template&id=7ba1d944&"
import script from "./FixBalances.vue?vue&type=script&lang=js&"
export * from "./FixBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports